import { startCase } from 'lodash-es'
import { getDocumentStatus } from '~/entities/document'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { useIsFeatureEnabled } from '~/shared/lib/feature-flags'
import { Chip, LocalIcon } from '~/shared/ui'

export function StatusChip({
  status,
  hasReviewer,
}: {
  status: apiClient.ReviewStatusEnum
  hasReviewer: boolean
}) {
  const isAutoReviewedEnabled = useIsFeatureEnabled('2026-06-auto-reviewed')
  const documentStatus = getDocumentStatus({ status, hasReviewer, isAutoReviewedEnabled })

  if (documentStatus === 'processing') {
    return <Chip rounded>Processing</Chip>
  }

  if (documentStatus === 'autoReviewed') {
    return (
      <Chip
        rounded
        success
        trailingIcon={
          <LocalIcon
            name="optiWink"
            size="18"
          />
        }
      >
        Auto Finished
      </Chip>
    )
  }

  return (
    <Chip
      rounded
      info={documentStatus === 'inProgress'}
      success={documentStatus === 'finished'}
      warning={documentStatus === 'awaiting'}
      disabled={documentStatus === 'rejected'}
    >
      {startCase(documentStatus)}
    </Chip>
  )
}
